import gql from 'graphql-tag';

export const FRAGMENT_BANNER = gql`
  fragment banner on Banners {
    channel
    headline_en
    headline_de
    subline_en
    subline_de
    desktop_alignment
    mobile_alignment
    text_color
    size
    mobile_images(limit: 2) {
      url
    }
    desktop_images(limit: 2) {
      url
    }
    button {
      text_en
      text_de
      url
      external_link
    }
  }
`;
